import { TBaseTreeNode } from "@/components/ui/tree/base-tree.types";
import {
  organizationPerimeterSchema,
  sitePerimeterSchema,
  TOrganizationPerimeter,
  TSitePerimeter,
} from "@/data/api/kili/consumption/types/user-organization-perimeter.type";

export type TUserPerimeterOrganizationTreeNode = TBaseTreeNode<TOrganizationPerimeter | TSitePerimeter>;

export function isNodeDataOrganization(
  node: TUserPerimeterOrganizationTreeNode,
): node is TBaseTreeNode<TOrganizationPerimeter> {
  return organizationPerimeterSchema.safeParse(node.data).success;
}

export function isNodeDataSite(node: TUserPerimeterOrganizationTreeNode): node is TBaseTreeNode<TSitePerimeter> {
  return sitePerimeterSchema.safeParse(node.data).success;
}
